import React from 'react';
import styles from './FilterItemParentContent.module.scss';
import { Checkbox } from 'antd';

export const FilterItemParentContent = ({
  item,
  showCheckbox,
  handleMultySelect,
  handleMultyDeselect,
  checked,
}) => {
  if (!item) return null;

  const onMultySelect = () => {
    if (checked) {
      handleMultyDeselect(item);
    } else {
      handleMultySelect(item);
    }
  };

  return (
    <div className={styles.root}>
      <div style={{ maxWidth: '250px' }}>{item.description || ''}</div>
      {showCheckbox ? (
        <Checkbox
          className={styles.checkbox}
          checked={checked}
          onChange={onMultySelect}
        />
      ) : (
        <span className={styles.amount}>{item.amount || null}</span>
      )}
    </div>
  );
};
